export class CreateOrganization {
  public static readonly type = "[Organizations] Create Organization";
  public constructor(public organizationName: string) {}
}
